export default {
  atLowerCase: 'в'
};
